import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'bw-empty-state-legacy',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EmptyStateComponentLegacy {

  @Input() iconName = '';
  @Input() primaryCopy: string;
  @Input() secondaryCopy: string;

}
